/**
 * Cookie de sessão first-party no domínio do frontend (BFF).
 * HttpOnly — inacessível ao JavaScript do browser.
 */
import type { NextApiResponse } from "next";
import { setCookie, destroyCookie } from "nookies";

/** Cookie-name must be a valid RFC 6265 token (no `@` — Express `cookie` rejects it). */
export const AUTH_COOKIE_NAME = "mbp_auth";

export function isCookieSecure(): boolean {
  if (process.env.COOKIE_SECURE === "true") return true;
  if (process.env.COOKIE_SECURE === "false") return false;
  // Piloto HTTP (sslip): Secure=false por padrão. Após TLS, defina COOKIE_SECURE=true.
  return false;
}

export function authCookieOptions(maxAgeSeconds: number) {
  const sameSiteEnv = (process.env.COOKIE_SAMESITE || "lax").toLowerCase();
  const sameSite =
    sameSiteEnv === "none" || sameSiteEnv === "strict" || sameSiteEnv === "lax"
      ? (sameSiteEnv as "lax" | "strict" | "none")
      : "lax";

  const secure = isCookieSecure();
  const resolvedSameSite = sameSite === "none" && !secure ? "lax" : sameSite;

  return {
    httpOnly: true,
    secure,
    sameSite: resolvedSameSite,
    path: "/",
    maxAge: maxAgeSeconds,
  } as const;
}

export function setAuthCookieOnResponse(
  res: NextApiResponse,
  token: string,
  maxAgeSeconds: number
) {
  setCookie({ res }, AUTH_COOKIE_NAME, token, authCookieOptions(maxAgeSeconds));
}

export function clearAuthCookieOnResponse(res: NextApiResponse) {
  destroyCookie({ res }, AUTH_COOKIE_NAME, {
    path: "/",
  });
  // Reforço com atributos alinhados (Secure/SameSite)
  const opts = authCookieOptions(0);
  setCookie({ res }, AUTH_COOKIE_NAME, "", {
    ...opts,
    maxAge: -1,
  });
}
